<form class="form" novalidate [formGroup]="form" (ngSubmit)="onFormSubmit()" *ngIf="me$ | async as me">
 
  <ion-list>

    <ion-item  mode="md" class="ion-no-padding">
      <ion-label position="stacked" mode="md">{{ 'NAME.FIRST_NAME' | translate }}</ion-label>
      <ion-input formControlName="firstname" (focus)="firstNameFocus=true;" (blur)="firstNameFirstBlur=true; firstNameFocus=false;" type="text" tabindex="10" [ngClass]="{
        'is-invalid': firstName.invalid && ( firstNameFirstBlur || tryToSubmit )
      }"></ion-input>

    </ion-item>
    <div class="invalid-feedback" *ngIf="firstName.invalid && !!firstName.errors?.required">
        {{ 'NAME.FIRST_NAME_REQUIRED' | translate }}
    </div>

    <ion-item mode="md" class="ion-no-padding">
      <ion-label position="stacked" mode="md">{{ 'NAME.LAST_NAME' | translate }}</ion-label>
      <ion-input formControlName="lastname" (focus)="lastNameFocus=true;" (blur)="lastNameFirstBlur=true; lastNameFocus=false;" type="text" tabindex="3" [ngClass]="{
        'is-invalid': lastName.invalid && ( lastNameFirstBlur || tryToSubmit )
      }"></ion-input>

    </ion-item>
    <div class="invalid-feedback" *ngIf="lastName.invalid && !!lastName.errors?.required">
        {{ 'NAME.LAST_NAME_REQUIRED' | translate }}
    </div>

  </ion-list>

  <ion-button type="submit" expand="full" tabindex="12" class="btn--large" [disabled]="form.invalid || ( me.firstName === firstName.value && me.lastName === lastName.value )" type="submit" expand="block" #submitBtn tabindex="12">{{ 'NAME.BTN_SAVE' | translate }}  </ion-button>

</form>